// import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
// import { hasSchemaACL } from '@frontend/auth-helpers';

/**
 * Determines if the user has access to the Brand Settings feature.
 *
 * To have access, the following conditions must be met:
 * 1. The user has the BRAND_SETTINGS_MODIFY permission for one or more of the passed locations
 * 2. The 'brand-settings' feature flag is enabled according to the passed getFeatureFlag function
 *
 * @param locationIds - Array of location IDs that are currently selected. At least one location ID must be present for access to be granted.
 * @param getFeatureFlagValue - Function to retrieve the value of a feature flag by name.
 *
 * @returns `true` if the user has access to Brand Settings, false otherwise
 */
export const hasAccess = (locationIds: string[], getFeatureFlagValue: (flagName: string) => boolean) => {
  if (locationIds.length === 0) return false;

  const hasFeatureFlag = getFeatureFlagValue('brand-settings');
  // TODO: Uncomment and update when Brand Settings ACL has been created
  // const hasPermission = locationIds.some((locationId) => hasSchemaACL(locationId, Permission.BRAND_SETTINGS_MODIFY));
  const hasPermission = true;
  return hasFeatureFlag && hasPermission;
};
